import React, { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import '../App.css';
import tobslogo from '../images/tobs-txt.svg';
import setcastLogo from '../images/Setcast_Logo_Icon_White_RGB.svg';

const ResetPassword = () => {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [token, setToken] = useState('');
  const { resetPassword } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  // Extract the token from the URL on component mount
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const resetToken = params.get('token');

    if (!resetToken) {
      setError('Invalid or missing password reset token');
    } else {
      setToken(resetToken);
    }
  }, [location]);

  const validatePassword = (password) => {
    if (password.length < 8) {
      return 'Password must be at least 8 characters long';
    }

    // Require at least one uppercase letter
    if (!/[A-Z]/.test(password)) {
      return 'Password must contain at least one uppercase letter';
    }

    // Require at least one number or special character
    if (!/[0-9!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(password)) {
      return 'Password must contain at least one number or special character';
    }

    return null;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate token
    if (!token) {
      setError('Invalid or missing password reset token');
      return;
    }

    // Validate password
    const passwordError = validatePassword(password);
    if (passwordError) {
      setError(passwordError);
      return;
    }

    // Check if passwords match
    if (password !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    try {
      setError('');
      setMessage('');
      setLoading(true);

      await resetPassword(token, password);

      setMessage('Password has been reset successfully');

      // Clear the form
      setPassword('');
      setConfirmPassword('');

      // Redirect to login after a short delay
      setTimeout(() => {
        navigate('/');
      }, 3000);
    } catch (err) {
      console.error('Error resetting password:', err);
      setError('Failed to reset password. The link may have expired or is invalid.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="loginForm">
      <form onSubmit={handleSubmit}>
        <div className="loginForm-container">
          <img style={{ height: 150 }} src={tobslogo} alt="Tobs Logo" />
          <h2>Reset Password</h2>

          {error && <p className="error">{error}</p>}
          {message && (
            <p className="password-reset-link" style={{ marginTop: '10px' }}>
              {message}<br />You will be redirected to login shortly...
            </p>
          )}

          {!token ? (
            <>
              <p className="password-reset-link">
                Invalid or missing reset token. Please request a new password reset link.
              </p>
              <Link to="/forgot-password" className="big-button">
                Request Password Reset
              </Link>
            </>
          ) : (
            <>
              <label>
                <input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="new password"
                  required
                />
              </label>

              <label>
                <input
                  type="password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  placeholder="confirm new password"
                  required
                />
              </label>

              <small className="password-reset-link" style={{ display: 'block', marginBottom: '10px' }}>
                At least 8 characters, one uppercase letter, and one number or special character.
              </small>

              <button type="submit" className="big-button" disabled={loading}>
                {loading ? 'Resetting...' : 'Reset Password'}
              </button>
            </>
          )}

          <Link to="/" className="password-reset-link" style={{ marginTop: '10px' }}>
            Back to Login
          </Link>
        </div>
      </form>
      <div className="footer-logo-container">
        <img style={{ height: 60 }} src={setcastLogo} alt="Setcast Logo" />
      </div>
    </div>
  );
};

export default ResetPassword;
